(function WebVaitorIndex($, Adzuki)
{
	"use strict";

}(jQuery, window.Adzuki || {}));